const lookup = <T extends Record<string, { readonly value: string }>, Value extends string>(
  constants: T,
  value: Value
): Extract<T[keyof T], { readonly value: Value }> => {
  for (const constant of Object.values(constants)) {
    if (constant.value === value) {
      return constant as any
    }
  }

  throw new RangeError(`指定された値が定数に存在しません。value: ${value}`)
}

export default lookup
